import Vue from "vue";
export const eventBus = new Vue({
  methods: {
    login() {
      this.$emit("login");
    },
    logout() {
      this.$emit("logout");
    },
    loginSuccessful() {
      this.$emit("loginSuccessful");
    },
    logoutSuccessful() {
      this.$emit("logoutSuccessful");
    },
    overlayLoadingStart() {
      this.$emit("overlayLoadingStart");
    },
    overlayLoadingEnd() {
      this.$emit("overlayLoadingEnd");
    }
  }
});
